// core/services/livesService.ts — local-seed service for the placeholder Live page.
//
// Live is a frontend-only placeholder (see nav.ts), so like videosService it
// reads from static seed data, not an API endpoint. Follow itself still goes
// through the real followsService/useFollow path (see core/data/live.ts).
//
// Components must NOT import this directly; use hooks/useLive.ts.

import type { LiveChannel, LiveCreator } from '@/core/models/live';
import { seedLiveChannels, seedLiveCreators } from '@/core/data/live';

export const livesService = {
  /** All live channels, seed order. */
  async all(): Promise<LiveChannel[]> {
    return seedLiveChannels;
  },

  /** A single channel by id, or null. */
  async byId(id: string): Promise<LiveChannel | null> {
    return seedLiveChannels.find((c) => c.id === id) ?? null;
  },

  /** The Top Live Creators rail. */
  async creators(): Promise<LiveCreator[]> {
    return seedLiveCreators;
  },
} as const;
